import "./style/PopupForm.css";
import {GrClose} from "react-icons/gr";
import {useEffect, useState} from "react";
import {addPlayer, getPlayer, updatePlayer, updatePlayerEmail} from "../../apicalls/players";
import {signupCoach} from "../../apicalls/coaches";
import {isAuthenticated} from "../../apicalls/auth";
import {buildRatingPayload, formatRatingInput} from "./playerRatingFields";

function PlayerForm({action, setPopup, player_id}) {
  const [values, setValues] = useState({
    full_name: "",
    phone: 0,
    password: "",
    email: "",
    date_of_birth: "",
    starting_rating: "",
    current_rating: "",
    rating_gender: "",
    original_email: "",
    matches_played: 0,
    error: false,
    success: false,
    loading: false,
  });

  const user = isAuthenticated();
  const accessToken = user?.access_token;

  let {
    full_name,

    phone,
    password,
    date_of_birth,
    email,
    original_email,
    starting_rating,
    current_rating,
    rating_gender,
    matches_played,
    error,
    success,
  } = values;

  useEffect(() => {
    if (action !== "Edit" || !accessToken) {
      return;
    }

    getPlayer(player_id, accessToken).then((data) => {
      setValues((prev) => ({
        ...prev,
        full_name: data[0]?.full_name,
        email: data[0]?.email || "",
        original_email: data[0]?.email || "",
        phone: data[0]?.phone,
        date_of_birth: data[0]?.date_of_birth
          ? new Date(data[0]?.date_of_birth).toISOString().slice(0, 10)
          : "",
        starting_rating: formatRatingInput(data[0]?.starting_rating || data[0]?.self_rated_seed),
        current_rating: formatRatingInput(data[0]?.current_rating),
        rating_gender: data[0]?.rating_gender || "",
        matches_played: data[0]?.matches_played || 0,
      }));
    });
  }, [action, player_id, accessToken]);

  const handleChange = (name) => (event) => {
    setValues({
      ...values,
      error: false,
      success: false,
      [name]: event.target.value,
    });
  };

  const onSubmit = (event) => {
    event.preventDefault();
    setValues({...values, error: false, success: false, loading: false});
    if (action === "Add") {
      if (!full_name || !email || !password) {
        setValues({
          ...values,
          error: "please fill required fields",
          success: false,
        });
        return;
      }
      signupCoach({email, password, user_type: 2}).then((data1) => {
        if (data1?.err?.code === "23505") {
          setValues({
            ...values,
            error: "Email already Exist",
            success: false,
            loading: false,
          });
          return;
        }
        date_of_birth = date_of_birth ? date_of_birth : null;
        addPlayer(
          {
            full_name,
            phone,
            user_id: data1.user_id,
            date_of_birth,
            rating_gender,
          },
          user.access_token
        ).then((data) => {
          if (data[0]?.id) {
            setValues({
              ...values,
              full_name: "",
              email: "",
              password: "",
              phone: "",
              date_of_birth: "",
              rating_gender: "",
              error: false,
              success: true,
              loading: false,
            });
          } else {
            setValues({
              ...values,
              error: "Please enter required values",
              success: false,
              loading: false,
            });
          }
        });
      });
    }
    if (action === "Edit") {
      if (!full_name || !phone || !date_of_birth) {
        setValues({...values, error: "please fill fields", success: false});
        return;
      }
      let ratingPayload = {};
      try {
        ratingPayload = buildRatingPayload({ startingRating: starting_rating });
      } catch (err) {
        setValues({
          ...values,
          error: err.message,
          success: false,
          loading: false,
        });
        return;
      }
      updatePlayer(
        player_id,
        {
          full_name,
          phone,
          date_of_birth,
          rating_gender: rating_gender || null,
          ...ratingPayload,
        },
        user.access_token
      ).then((data) => {
        if (data[0].id) {
          const emailChanged = email && email !== original_email;
          const emailUpdate = emailChanged
            ? updatePlayerEmail(player_id, email, user.access_token)
            : Promise.resolve(data);

          emailUpdate.then((emailData) => {
            if (emailData?.detail || emailData?.details) {
              setValues({
                ...values,
                error: emailData.detail || emailData.details,
                success: false,
                loading: false,
              });
              return;
            }

          setValues({
            ...values,
            full_name: "",
            email: "",
            original_email: "",
            phone: "",
            date_of_birth: "",
            starting_rating: "",
            current_rating: "",
            rating_gender: "",
            matches_played: 0,
            error: false,
            success: true,
            loading: false,
          });
          });
        } else {
          setValues({
            ...values,
            error: "Please fill required fields",
            success: false,
            loading: false,
          });
        }
      });
    }
  };

  return (
    <div className="popup">
      <div className="popup-inner">
        <div
          className="close-btn"
          onClick={() => {
            setPopup("");
          }}
        >
          <GrClose />
        </div>
        <h1>{action} Player</h1>.
        <div className="container">
          <div className="row">
            {error ? <span className="error">{error}</span> : ""}
            {success ? (
              <span className="success">
                Player {action === "Add" ? "Added" : "Edited"} Successfully
              </span>
            ) : (
              ""
            )}
            <div className="form-content col-lg-6">
              <label htmlFor="">Full Name*</label>
              <br />
              <input
                type="text"
                value={full_name}
                onChange={handleChange("full_name")}
                placeholder="Enter Full Name"
                required
              />
            </div>
            {action === "Add" || action === "Edit" ? (
              <div className="form-content col-lg-6">
                <label htmlFor="">Email Address*</label>
                <br />
                <input
                  type="email"
                  value={email}
                  onChange={handleChange("email")}
                  placeholder="Enter Email Address"
                  required
                />
              </div>
            ) : (
              ""
            )}
            <div className="form-content col-lg-6">
              <label htmlFor="">phone number</label>
              <br />
              <input
                type="text"
                value={phone}
                onChange={handleChange("phone")}
                placeholder="Enter phone number"
              />
            </div>
            <div className="form-content col-lg-6">
              <label htmlFor="">Date of birth</label>
              <br />
              <input
                type="date"
                value={date_of_birth}
                onChange={handleChange("date_of_birth")}
              />
            </div>
            <div className="form-content col-lg-6">
              <label htmlFor="">Gender</label>
              <br />
              <select value={rating_gender} onChange={handleChange("rating_gender")}>
                <option value="">Unknown</option>
                <option value="M">Male</option>
                <option value="F">Female</option>
              </select>
            </div>
            {action === "Edit" ? (
              <>
                <div className="form-content col-lg-6">
                  <label htmlFor="">Manual starting rating</label>
                  <br />
                  <input
                    type="number"
                    step="0.001"
                    min="0"
                    value={starting_rating}
                    onChange={handleChange("starting_rating")}
                    placeholder="e.g. 5.750"
                  />
                </div>
                <div className="form-content col-lg-6">
                  <label htmlFor="">Current rating</label>
                  <br />
                  <input
                    type="text"
                    value={current_rating || "Not rated yet"}
                    disabled
                  />
                  <small>
                    Matches played: {matches_played || 0}. Saving manual starting rating replays confirmed match history.
                  </small>
                </div>
              </>
            ) : (
              ""
            )}
            {action === "Add" ? (
              <div className="form-content col-lg-6">
                <label htmlFor="">Create Password*</label>
                <br />
                <input
                  type="password"
                  value={password}
                  onChange={handleChange("password")}
                  placeholder="player password"
                />
              </div>
            ) : (
              ""
            )}
            <div className="form-content col-lg-12">
              <button onClick={onSubmit}>{action} Player</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PlayerForm;
